import { Trash } from "@phosphor-icons/react";
import { TYPE_LABELS, dietaryLabel, guestType, initials, typeTone } from "@/lib/guests";

// Shared guest row for the client Guests page and the staff event planning section.
export function GuestRow({ guest, onEdit, onDelete }) {
  const type = guestType(guest);
  const diet = dietaryLabel(guest);
  return (
    <div className="flex items-center gap-4 p-4" data-testid={`guest-row-${guest.id}`}>
      <button
        type="button"
        onClick={() => onEdit(guest)}
        className="flex min-w-0 flex-1 items-center gap-4 text-left"
        data-testid={`edit-guest-${guest.id}`}
      >
        <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-xs font-medium text-white ${typeTone(type)}`}>
          {initials(guest.name)}
        </span>
        <span className="min-w-0">
          <span className="block truncate font-heading text-lg text-primary">{guest.name}</span>
          <span className="mt-0.5 flex flex-wrap items-center gap-x-2 text-xs uppercase tracking-wide text-muted-foreground">
            <span>{TYPE_LABELS[type]}</span>
            {guest.table_number && <span>· Table {guest.table_number}</span>}
            {diet && <span className="text-secondary">· {diet}</span>}
          </span>
        </span>
      </button>
      <button
        type="button"
        onClick={() => onDelete(guest)}
        className="rounded-lg p-2 text-muted-foreground transition-colors duration-200 hover:bg-destructive/10 hover:text-destructive"
        data-testid={`delete-guest-${guest.id}`}
        aria-label={`Remove ${guest.name}`}
      >
        <Trash size={18} />
      </button>
    </div>
  );
}
